import React from "react";
import _ from "lodash";

const withFormState = (Component, formInitialState = {}) => {
  //eslint-disable-next-line react/display-name
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        initialState: formInitialState,
        formData: formInitialState,
        formErrors: {},
        isFormLoading: false,
        forcePristine: false,
      };
    }

    setInitialValues = (fieldsValues) => {
      this.setState((prevState) => ({
        formData: { ...fieldsValues },
        initialState: { ...fieldsValues },
        forcePristine: false,
      }));
    };

    setFormFieldValue = (fieldsValues, cb) => {
      this.setState(
        (prevState) => ({ forcePristine: false, formData: { ...prevState.formData, ...fieldsValues } }),
        cb
      );
    };

    setFormErrors = (errors, isLoading = false) => {
      this.setState({ formErrors: errors, isFormLoading: isLoading });
    };

    setFormFieldError = (field, value) => {
      this.setState({ formErrors: { ...this.state.errors, [field]: value } });
    };

    setFormLoading = () => {
      this.setState({ isFormLoading: true });
    };

    unsetFormLoading = () => {
      this.setState({ isFormLoading: false });
    };

    resetForm = () => {
      this.setState({ isFormLoading: false, formData: {}, formErrors: {} });
    };

    resetFormErrors = () => {
      this.setState({ formErrors: {} });
    };

    resetFields() {
      const args = [...arguments];
      let fieldToReset = {};
      args.forEach((field) => (fieldToReset[field] = this.state.initialState[field]));
      this.setState((prevState) => ({ formData: { ...prevState.formData, ...fieldToReset } }));
    }

    forceFormAsPristine = () => {
      this.setState({ forcePristine: true });
    };

    areFieldsPristine() {
      if (this.state.forcePristine) return true;

      const args = [...arguments];
      let nonPristineFields = [];
      args.forEach((field) => {
        if (!_.isEqual(this.state.initialState[field], this.state.formData[field])) {
          nonPristineFields.push(field);
        }
      });
      return nonPristineFields.length === 0;
    }

    setDataForm = (values) => {
      this.setState({
        isFormLoading: false,
        formData: { ...this.state.formData, ...values },
        formErrors: {},
      });
    };

    render() {
      return (
        <Component
          {...this.props}
          setDataForm={this.setDataForm}
          setFormFieldValue={this.setFormFieldValue}
          areFieldsPristine={this.areFieldsPristine.bind(this)}
          forceFormAsPristine={this.forceFormAsPristine}
          setInitialValues={this.setInitialValues}
          setFormErrors={this.setFormErrors}
          setFormLoading={this.setFormLoading}
          unsetFormLoading={this.unsetFormLoading}
          resetForm={this.resetForm}
          formData={this.state.formData}
          formErrors={this.state.formErrors}
          resetFields={this.resetFields.bind(this)}
          isFormLoading={this.state.isFormLoading}
          initialState={this.state.initialState}
          setFormFieldError={this.setFormFieldError}
          resetFormErrors={this.resetFormErrors}
        />
      );
    }
  };
};

export default withFormState;
